import SwitchContainer from "../../../../Components/Forms/FormsWidgets/Switch/Switch"

const Switch = () => {
  return (
    <div className='page-body'>
      <SwitchContainer />
    </div>
  )
}

export default Switch